export const verticalBlinds = {
  overview: {
    titles: ["Wide array of choices", "Safe", "Easy to clean"],
    contents: [
      "Vertical blinds come in various blade widths, finishes, texture and colours. High-quality and with superior durability, they surely will add an extra touch of finesse to any space.",
      "Vertical blinds in NZ are guaranteed safe, without unnecessary cords that may pose as risks to children and pets.",
      "These types of blinds are often made of stain-resistant materials. There are also options to go for fire-safe and block out materials. They’re easy to clean – all you need is a cleaning cloth."
    ]
  },
  description: {
    titles: ["", ""],
    contents: [
      "Vertical blinds are the ideal alternative to traditional curtains. For those who are looking to transition from curtains to blinds, vertical blinds would be the top recommended option. Made of light materials and with roughly the same level of manageability, they are akin to your traditional curtains, but made better. The extra feature of allowing you to adjust how you filter natural light into a room – thus controlling privacy – puts vertical blinds notches above your traditional curtains. In addition, they offer better heat and cold installation that ordinary fabric curtains.",
      "Vertical blinds also come in a wide assortment of materials, colours, and customisable fixtures and fittings. They are versatile enough for commercial or residential spaces in NZ."
    ]
  }
};
